import {
  differenceInMinutes,
  differenceInMilliseconds,
  parseISO,
} from 'date-fns';
import i18next from 'i18next';

const leadingZero = (integer, showNegative = true) => {
  const isNegativeNumber = integer < 0;
  const isLowerThan10 = integer < 10;

  if (!isNegativeNumber && !isLowerThan10) {
    return showNegative ? integer : Math.abs(integer);
  }

  if (isNegativeNumber && integer > -10) {
    return showNegative ? `-0${Math.abs(integer)}` : `0${Math.abs(integer)}`;
  }

  if (!isNegativeNumber && isLowerThan10) {
    return `0${integer}`;
  }
  return showNegative ? integer : Math.abs(integer);
};

const getDifferenceMinutes = (minuteLeft, minuteRight) => {
  let minute1 = minuteLeft;
  let minute2 = minuteLeft;
  if (typeof minuteLeft === 'string') {
    minute1 = parseISO(minuteLeft);
  }
  if (typeof minuteRight === 'string') {
    minute2 = parseISO(minuteRight);
  }
  return Math.abs(differenceInMinutes(minute1, minute2));
};

const getDifferenceMs = (msLeft, msRight) => {
  let second1 = msLeft;
  let second2 = msRight;
  if (typeof msLeft === 'string') {
    second1 = parseISO(msLeft);
  }
  if (typeof msRight === 'string') {
    second2 = parseISO(msRight);
  }
  return Math.abs(differenceInMilliseconds(second1, second2));
};

const formatMinutesSecondsFromMs = (milliseconds) => {
  const timeSeconds = milliseconds / 1000;
  const minutes = Math.floor(timeSeconds / 60);
  const seconds = Math.floor(timeSeconds % 60);
  let output = `${minutes} ${i18next.t('common:minute', { count: minutes })}`;
  if (seconds !== 0) {
    output += ` ${seconds} ${i18next.t('common:second', { count: seconds })}`;
  }
  return output;
};

export {
  leadingZero,
  getDifferenceMinutes,
  getDifferenceMs,
  formatMinutesSecondsFromMs,
};
